// extracted by mini-css-extract-plugin
module.exports = {"container":"Canvas_container__1t-Su","canvas":"Canvas_canvas__1dMMN","canvasMount":"Canvas_canvasMount__PxatZ","resize":"Canvas_resize__DW0k0"};